import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
    setAddonProducts(state, payload) {
        state.addonProducts = payload;
      },
};

export default mutations;
